import React, { useRef } from 'react';
import "slick-carousel/slick/slick.css";
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from "swiper/react";
import { Lazy } from 'swiper';
import OfferSlide from './OfferSlide';
import SwiperCore, { Pagination } from 'swiper';
SwiperCore.use([Pagination]);
var OfferCarousel = function (_a) {
    var offers = _a.offers, getFonts = _a.getFonts;
    var prevNavRef = useRef(null);
    var nextNavRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'offer-carousel-wrapper' },
            React.createElement(Swiper, { spaceBetween: 10, className: "my-swiper", modules: [Lazy], pagination: {
                    clickable: true
                }, onInit: function (swiper) {
                    swiper.params.navigation.prevEl = prevNavRef.current;
                    swiper.params.navigation.nextEl = nextNavRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                } }, offers === null || offers === void 0 ? void 0 : offers.map(function (offerData) {
                return React.createElement(SwiperSlide, null,
                    " ",
                    React.createElement(OfferSlide, { offerData: offerData, getFonts: getFonts }));
            })))));
};
export default OfferCarousel;
